import { initializeApp } from 'firebase/app'
import { connectFirestoreEmulator, getFirestore, initializeFirestore } from 'firebase/firestore'
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth'
import { connectDatabaseEmulator, getDatabase } from 'firebase/database'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTHDOMAIN,
  databaseURL: import.meta.env.VITE_DATABASE_URL,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
}
// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
// support for local emulator for tests
// https://stackoverflow.com/questions/59336720/cant-use-cypress-to-test-app-using-using-firestore-local-emulator
export const db = import.meta.env.VITE_USE_FIREBASE_EMULATOR
  ? initializeFirestore(app, {
      experimentalForceLongPolling: true,
    })
  : getFirestore(app)
export const realtimeDB = getDatabase(app)
export const storage = getStorage(app)

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR) {
  connectAuthEmulator(auth, 'http://localhost:9099')
}

export const googleProvider = new GoogleAuthProvider()

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR) {
  connectFirestoreEmulator(db, 'localhost', 8080)
}

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR) {
  connectDatabaseEmulator(realtimeDB, 'localhost', 9000)
}

if (import.meta.env.VITE_USE_FIREBASE_EMULATOR) {
  connectStorageEmulator(storage, 'localhost', 9199)
}
